import { render, staticRenderFns } from "./ColorPickerButton.vue?vue&type=template&id=53d6a9d8&"
import script from "./ColorPickerButton.vue?vue&type=script&lang=ts&"
export * from "./ColorPickerButton.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPickerButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports